import type { ListWorkFlowsFilter } from './ApiQueryParams.types.tsx';

// analytics constants
export const APP_NAME = 'jira';
export const TEAM_NAME = 'helix';
export const SOURCE_NAME = 'listWorkflows';
export const WORKFLOW_NAME = 'workflowName';

export const PACKAGE_NAME = 'jira-admin-pages-list-workflows';

export const WORKFLOWS_ACTIONS = 'workflowsActions';
export const WORKFLOWS_SCHEME = 'workflowScheme';

export const SYSTEM_WORKFLOW_JIRA_NAME = 'jira';
export const SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME = 'Builds Workflow';

export const DEFAULT_PAGE_SIZE = 10;
export const defaultListWorkFlowsFilter: ListWorkFlowsFilter = {
	pageNumber: 1,
	pageSize: DEFAULT_PAGE_SIZE,
	expand: [
		'default',
		'hasDraftWorkflow',
		'schemes',
		'operations',
		'projects',
		'transitions.count',
		'transitions.limits.count',
		'statuses.count',
		'statuses.limits.count',
	],
	orderBy: 'name',
	sortDirection: 'ASC',
	isActive: true,
};

export const ORDER: Readonly<{
	ASC: 'asc';
	DESC: 'desc';
}> = Object.freeze({
	ASC: 'asc',
	DESC: 'desc',
});

export const FILTER_CHANGE_ANALYTICS: Readonly<{
	ACTION: 'changed';
	ACTION_SUBJECT: 'filterSearch';
}> = Object.freeze({
	ACTION: 'changed',
	ACTION_SUBJECT: 'filterSearch',
});

export const PAGE_SIZE_CHANGE_ANALYTICS: Readonly<{
	ACTION: 'changed';
	ACTION_SUBJECT: 'pageSize';
}> = Object.freeze({
	ACTION: 'changed',
	ACTION_SUBJECT: 'pageSize',
});

export const API_PREFIX = 'gateway/api/jira/project-configuration';
